module.exports = __webpack_public_path__ + "img/skype.76d288b9.png";